<template>
    <div :style="artistCardsStyle" class="artist-cards-container">
        <div v-for="(artist, indx) in artists" :key="indx" class="artist-card">
            <img
                class="artist-avatar"
                :src="artist.profile_picture"
                @click="handleProfileClick(artist.slug)"
                alt="artist-profile-pic"
            />
            <div class="artist-info-wrapper">
                <div class="artist-name-and-rating">
                    <p class="artist-name">
                        {{ artist.artist_name }}
                    </p>
                    <div v-if="showArtistRating(artist.rating)" class="artist-rating">
                        <img class="rait-img" src="/images/Star1.png" alt="rating-star" />
                        <p class="rating">
                            {{ artist.rating }}
                        </p>
                    </div>
                </div>
                <p
                    v-if="showArtistSocialReach(artist.social_reach)"
                    class="artist-social-reach"
                >
                    {{ `${artistSocialReach(artist.social_reach)} Followers` }}
                </p>
                <p class="artist-location">
                    {{ artistCityState(artist.location) }}
                </p>
                <div class="artist-keywords">
                    <div
                        v-for="(keyword, indx) in artist.keywords.split(',')"
                        :key="indx"
                        class="artist-keyword"
                    >
                        {{ keyword }}
                    </div>
                </div>
                <div class="artist-info-divider"></div>
                <div class="artist-event-payout-info">
                    {{ artistEventPayout(artist.propose) }}
                </div>
                <div class="artist-card-footer">
                    <button @click="goToChat(artist)" class="message-btn">Message</button>
                    <button @click="rebookArtist(artist)" class="rebook-btn">Rebook</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import useCheckScreen from '@/composables/useCheckScreen.js'
    const URLS = {
        redirect: {
            booking: '/booking-manager',
            mailChat: '/profile/mail-chat'
        }
    }
    export default {
        name: 'ArtistCards',
        props: {
            artists: {
                required: true,
                type: Array
            }
        },
        computed: {
            URLS: () => URLS,
            showArtistRating: () => (rating) => rating && rating > 0,
            showArtistSocialReach: () => (reach) => reach && reach > 0,
            artistCardsStyle: (self) =>
                self.screen.isMobile.value ? { 'justify-content': 'center' } : {}
        },
        setup() {
            const { isMobile } = useCheckScreen()

            return {
                screen: {
                    isMobile
                }
            }
        },
        methods: {
            goToChat(artist) {
                sessionStorage.setItem('recipient_id', artist.artist_user_id)
                window.open(this.URLS.redirect.mailChat, '_blank')
            },
            rebookArtist(artist) {
                localStorage.setItem('artistEmail', artist.artist_email)
                localStorage.setItem('artistName', artist.artist_name)
                window.open(
                    `${this.URLS.redirect.booking}/#referred-by-venue-completed-event`,
                    '_blank'
                )
            },
            artistCityState(address) {
                let addressArr = address.replace(', USA', '').split(',').reverse()
                let city = addressArr[1]
                let state = addressArr[0].trim().split(' ')[0]

                return `${city}, ${state}`
            },
            artistSocialReach(num) {
                if (num >= 1_000_000_000) {
                    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                }
                if (num >= 1_000_000) {
                    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                }
                if (num >= 1_000) {
                    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                }
                if (num <= 0 || !num) {
                    return 'N/A'
                }
                return num.toFixed(0).toString()
            },
            artistEventPayout(propose) {
                return `$${propose.booked_payout} / ${propose.duration_minutes}min Set`
            },
            handleProfileClick(slug) {
                window.open(`/artists/${slug}`, '_blank')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .artist-cards-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        display: flex;
        flex-direction: row;
        max-width: 1050px;
        gap: 20px 21px;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;

        .artist-card {
            width: 336px;
            height: 513px;
            border-radius: 15px;
            background: #262626;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .artist-avatar {
                cursor: pointer;
                width: 336px;
                height: 250px;
                object-fit: cover;
                border-radius: 15px 15px 0px 0px;
            }
            .artist-info-wrapper {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 5px;
                border-radius: 0px 0px 15px 15px;
                padding: 15px 20px 20px 20px;

                .artist-name-and-rating {
                    display: flex;
                    flex-direction: row;
                    gap: 10px;

                    .artist-name {
                        overflow: hidden;
                        color: #acacac;
                        text-overflow: ellipsis;
                        font-family: Instrument Sans;
                        font-size: 26px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 120%;
                        letter-spacing: -0.52px;
                    }
                    .artist-rating {
                        display: flex;
                        flex-direction: row;
                        gap: 6px;

                        img {
                            width: 18px;
                            height: 18px;
                        }
                        .rating {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 125%;
                        }
                    }
                }
                .artist-social-reach {
                    color: #acacac;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
                .artist-location {
                    color: #646464;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                }
                .artist-keywords {
                    max-width: 296px;
                    margin-top: 5px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    overflow-x: hidden;
                    flex-wrap: nowrap;
                    gap: 5px;

                    .artist-keyword {
                        display: flex;
                        padding: 3px 10px 4px 10px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 100px;
                        border: 1px solid #8b8b8b;
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 135%;
                        letter-spacing: 0.12px;
                        text-wrap: nowrap;
                    }
                }
                .artist-info-divider {
                    width: 100%;
                    height: 1px;
                    background: #8b8b8b;
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
                .artist-event-payout-info {
                    margin-bottom: 10px;
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.22px;
                }
                .artist-card-footer {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .message-btn {
                        padding: 11px 30px 12px 30px;
                        border-radius: 100px;
                        border: 1px solid #c9cd00;
                        background: #262626;
                        color: #c9cd00;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                    }
                    .rebook-btn {
                        background: none;
                        color: #c9cd00;
                        text-align: right;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 125%;
                        text-decoration-line: underline;
                    }
                }
            }
        }
    }
</style>
